"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCobrandCardFullName = exports.getCobrandCardNameWithoutPartner = exports.getCobrandCardNamePrefix = exports.PUBLIC_COBRAND_CARD_CONFIG_BY_PARTNER = exports.PartnerDashboardSubOrgTerminology = exports.CobrandCardProduct = exports.CobrandPartnerId = void 0;
/** @TranslateToPython @TranslateToEnum */
var CobrandPartnerId;
(function (CobrandPartnerId) {
    CobrandPartnerId["ForestRiver"] = "ForestRiver";
})(CobrandPartnerId || (exports.CobrandPartnerId = CobrandPartnerId = {}));
/** The Aven product a cobrand card fronts. Keys a partner's card art. */
var CobrandCardProduct;
(function (CobrandCardProduct) {
    CobrandCardProduct["homeEquity"] = "homeEquity";
    CobrandCardProduct["rewards"] = "rewards";
    CobrandCardProduct["deposit"] = "deposit";
})(CobrandCardProduct || (exports.CobrandCardProduct = CobrandCardProduct = {}));
var PartnerDashboardSubOrgTerminology;
(function (PartnerDashboardSubOrgTerminology) {
    PartnerDashboardSubOrgTerminology["Dealership"] = "dealership";
})(PartnerDashboardSubOrgTerminology || (exports.PartnerDashboardSubOrgTerminology = PartnerDashboardSubOrgTerminology = {}));
// Adding a new CobrandPartnerId without an entry here will fail tsc
exports.PUBLIC_COBRAND_CARD_CONFIG_BY_PARTNER = {
    [CobrandPartnerId.ForestRiver]: {
        displayName: 'Forest River',
        cardNames: {
            [CobrandCardProduct.homeEquity]: 'Homeline',
            [CobrandCardProduct.rewards]: 'Journey Rewards',
            [CobrandCardProduct.deposit]: 'Trailhead Deposit',
        },
        backgroundColor: '#1B5E20',
        accentColor: '#1D385B',
        partnerDashboardSubOrgTerminology: PartnerDashboardSubOrgTerminology.Dealership,
    },
};
/**
 * The partner's card name before the trailing "Card", e.g. "Forest River Homeline", for documents that append
 * that word themselves as part of a longer title.
 */
const getCobrandCardNamePrefix = ({ partnerId, cardProduct }) => {
    const { displayName, cardNames } = exports.PUBLIC_COBRAND_CARD_CONFIG_BY_PARTNER[partnerId];
    return `${displayName} ${cardNames[cardProduct]}`;
};
exports.getCobrandCardNamePrefix = getCobrandCardNamePrefix;
/** The card's name without the partner's name in front, e.g. "Journey Rewards Card". */
const getCobrandCardNameWithoutPartner = ({ partnerId, cardProduct }) => {
    const { cardNames } = exports.PUBLIC_COBRAND_CARD_CONFIG_BY_PARTNER[partnerId];
    return `${cardNames[cardProduct]} Card`;
};
exports.getCobrandCardNameWithoutPartner = getCobrandCardNameWithoutPartner;
/** The customer-facing name of the partner's card, e.g. "Forest River Journey Rewards Card". */
const getCobrandCardFullName = ({ partnerId, cardProduct }) => {
    const { displayName } = exports.PUBLIC_COBRAND_CARD_CONFIG_BY_PARTNER[partnerId];
    return `${displayName} ${(0, exports.getCobrandCardNameWithoutPartner)({ partnerId, cardProduct })}`;
};
exports.getCobrandCardFullName = getCobrandCardFullName;
